module.exports = __webpack_public_path__ + "static/media/ste_wor_sit_spe_met.9c75b18d.png";